import { registerSW } from 'virtual:pwa-register';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from '@/App';
// Pixel display + retro body fonts (self-hosted, PWA-friendly).
import '@fontsource/press-start-2p/400.css';
import '@fontsource/vt323/400.css';
import '@/styles/global.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

if ('serviceWorker' in navigator) {
  // On every deploy a new service worker + precache manifest ship. Without
  // the `onNeedRefresh` hook below the browser waits for all open tabs to
  // fully close before activating the new SW — meaning users "refresh and
  // still see the old version" (classic two-refresh PWA bug).
  //
  // `updateSW(true)` calls skipWaiting on the new SW and reloads the page
  // once it takes control, so a single refresh always lands on the latest
  // build.
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      void updateSW(true);
    },
  });
}
